import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { anularCubicaje } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionEliminarCubicajeView } from '../components/OperacionEliminarCubicajeView'

export const OperacionEliminarCubicaje = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionEliminarCubicajeView
        silo={silo}
        aceptar={async () => {
          try {
            await anularCubicaje(silo)
            closeDialog()
            enqueueSnackbar('Anulado de cubicaje correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Anulado de cubicaje incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('ELIMINAR_CUBICAJE_SILO')
        }, [closeDialog])}
      />
    )
  })
)
